// Styles for RosterSection component
// Add styled components here if needed in the future
import { Box, Flex } from '@pinchenterprisesnpm/friday-ui'
import styled from 'styled-components'

export const StyledRosterSection = styled(Box)<{
  isSelectionDisabled?: boolean
}>`
  border: 1px solid ${({ theme: { palette } }) => palette.border};
  border-radius: 3px;
  padding: ${({ theme: { mp } }) => mp.sm};
  margin: ${({ theme: { mp } }) => mp.sm};
  cursor: pointer;
  ${({ isSelectionDisabled, theme: { palette } }) =>
    !isSelectionDisabled &&
    `
  &:hover {
    border: 1px solid ${palette.primary};
  }`}
`

export const BoldBlueSpan = styled.span`
  color: ${({ theme: { palette } }) => palette.primary};
  font-weight: ${({
    theme: {
      font: { weights },
    },
  }) => weights.bold};
`

export const StyledRosterSectionContainer = styled(Flex)`
  cursor: pointer;
`
